import React, { useEffect, useState } from "react";
import UpperFooterSlider from "../../../Layout/Upper Footer Slider/UpperFooterSlider";
import { Link } from "react-router-dom";
import { GetService, PostService } from "../../../../Services/ConstantService";
import { API_URL } from "../../../../Services/ApiService";
import { toastEmmit } from "../../../../Helper/Toastr";
import { BounceLoader } from "react-spinners";

export default function AllProducts() {
  const [ProductList, setProductList] = useState([]);
  const [Loading, setLoading] = useState(false);

  useEffect(() => {
    GetProductsList();
  }, []);

  const GetProductsList = () => {
    setLoading(true);
    PostService(API_URL?.GET_PRUDUCTS_LIST, {}).then((res) => {
      console.log(res);
      if (res?.data?.status) {
        setProductList(res?.data?.data);
      }
      setLoading(false);
    });
  };

  return (
    <div className="Gallery-Wraps-2 retouching">
      <main>
        {/* hera banner start */}
        <div
          className="tp-breadcrumb__area fix tp-breadcrumb-height"
          // data-background="assets/img/breadcrumb/Retouching2.png"
          style={{
            backgroundImage: 'url("assets/img/breadcrumb/Retouching2.png")',
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="tp-breadcrumb__content text-center z-index-5">
                  <h3 className="tp-breadcrumb__title">
                    Our Products <br />
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* hero banner end */}
        <div className="tp-blog__area p-relative  pt-50 pb-40">
          <div className="container">
            <div className="row">
              {ProductList &&
                ProductList.map((data) => (
                  <div
                    className="col-xl-4 col-lg-4 col-md-6 mb-40  wow tpfadeUp"
                    data-wow-duration=".9s"
                    data-wow-delay=".3s"
                    style={{
                      visibility: "visible",
                      animationDuration: "0.9s",
                      animationDelay: "0.3s",
                      animationName: "tpfadeUp",
                    }}
                  >
                    <div className="tp-blog__item">
                      <div className="tp-blog__thumb" style={{width:'352px', height:'271px', objectFit:'contain'}}>
                      <Link to={`${data?.id}`}>
                          <img
                            className="w-100"
                            src={data?.product_image}
                            alt=""
                          />
                        </Link>
                      </div>
                      <div className="tp-blog__content">
                        <h5 className="tp-blog__title">
                          <Link to={`${data?.id}`}>
                            {data?.product_title}
                          </Link>
                        </h5>
                        <div className="tp-blog__meta">
                          <span>{data?.description}</span>
                        </div>
                        <div className="tp-blog__meta">
                          <span style={{ fontWeight: 800 }}>
                            Prints starts at ${data?.price}
                          </span>
                        </div>
                        <div className="tp-blog__link">
                        <Link to={`${data?.id}`}>Shop Canvas</Link>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
  
              {/* <div
                className="col-xl-4 col-lg-4 col-md-6 mb-40  wow tpfadeUp"
                data-wow-duration=".9s"
                data-wow-delay=".3s"
                style={{
                  visibility: "visible",
                  animationDuration: "0.9s",
                  animationDelay: "0.3s",
                  animationName: "tpfadeUp",
                }}
              >
                <div className="tp-blog__item">
                  <div className="tp-blog__thumb">
                    <Link to={"/gallery-walls"}>
                      <img
                        className="w-100"
                        src="assets/img/blog/Gallery Walls.png"
                        alt=""
                      />
                    </Link>
                  </div>
                  <div className="tp-blog__content">
                    <h5 className="tp-blog__title">
                      <Link to={"/gallery-walls"}>GALLERY WALLS</Link>
                    </h5>
                    <div className="tp-blog__meta">
                      <span>
                        Upload photos, see your beautiful tray and we'll have it
                        shipped to your door.
                      </span>
                    </div>
                    <div className="tp-blog__meta">
                      <span style={{ fontWeight: 800 }}>Tray price $49</span>
                    </div>
                    <div className="tp-blog__link">
                      <Link to={"/gallery-walls"}>Shop Gallery Walls</Link>
                    </div>
                  </div>
                </div>
              </div> */}
                
            </div>
          </div>
        </div>

        <UpperFooterSlider />
      </main>

      {Loading ? (
        <div className="LoaderSpinner">
          <BounceLoader
            color={"#003bff"}
            loading={Loading}
            speedMultiplier={2}
            size={50}
          />
          <div>Loading... Please wait.</div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
}
